import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import { Spinner } from 'components/Spinner'

import { paymentApi } from 'api'
import { useHistory } from 'react-router-dom'

const SharePage = (props) => {
  const history = useHistory()

  useEffect(() => {
    window.location.search &&
      paymentApi
        .registerSubscription({
          subscription_id: [...new URLSearchParams(window.location.search)]
            .find(([key]) => key === 'session_id')?.[1]
            .toString(),
        })
        .then((res) => {
          history.push('/dashboard/pro')
        })
  }, [history])

  return <Spinner className="section default_mod_v2 center_mod"></Spinner>
}

const mapStateToProps = ({ auth: { user, error, attributes } }) => ({
  user,
  authError: error,
  attributes,
})

export default connect(mapStateToProps)(SharePage)
